import React, { useState } from 'react'
import { Button } from 'components/buttons'
import { useStyles } from './quickSellButtons.css'

export const QuickSellButtons = ({ quickSelling, quickSell, localize, isInDialog, context, data }) => {
    const classes = useStyles()

    const handleQuickSell = React.useCallback(soldByChannel => (e) => {
        e.stopPropagation()
        const ids = isInDialog ? [...context.selectedIds] : [ data.entity.id ]
        quickSell(soldByChannel, ids, isInDialog)
      }, [isInDialog, context, data, quickSell])
    return (
      <div className={classes.root}>
        <Button
            className={classes.button}
            disabled={quickSelling}
            isLoading={quickSelling}
            marginRight={10}
            onClick={handleQuickSell(0)}>{localize('bottles.sellInBarButton')}</Button>
        <Button
            className={classes.button}
            disabled={quickSelling}
            isLoading={quickSelling}
            marginRight={10}
            onClick={handleQuickSell(1)}>{localize('bottles.sellInMachineButton')}</Button>
        <Button
            className={classes.button}
            disabled={quickSelling}
            isLoading={quickSelling}
            marginRight={10}
            onClick={handleQuickSell(2)}>{localize('bottles.sellInShopButton')}</Button>
        <Button
            className={classes.button}
            disabled={quickSelling}
            isLoading={quickSelling}
            marginRight={10}
            onClick={handleQuickSell(3)}>{localize('bottles.sellInEShopButton')}</Button>
        <Button
            className={classes.button}
            disabled={quickSelling}
            isLoading={quickSelling}
            marginRight={10}
            onClick={handleQuickSell(4)}>{localize('bottles.sellInOtherWayButton')}</Button>
      </div>
    )
  }